import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateMyPasswordAction } from '../../../redux/actions/meActions';
import ChangePasswordForm from './ChangePasswordForm';

const ChangePassword = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleChangePassword = async (data) => {
    setLoading(true);
    dispatch(updateMyPasswordAction(data));
    setLoading(false);
  };

  return <ChangePasswordForm handleChangeMyInfo={handleChangePassword} loading={loading} />;
};

export default ChangePassword;
